module.exports = __webpack_public_path__ + "static/media/Mano 5.271d0d90.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Mano 5.png
// module id = 187
// module chunks = 0